import React from 'react';

import {StageEntryHistoryPanelState} from 'FileStates';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import StageEntryFile from 'workflows/stage-entries/StageEntryFile';
import StageEntryHistoryPanel from 'workflows/stage-entries/StageEntryHistoryPanel';

class StageEntryHistoryPanelView extends ReactPanelBaseView<StageEntryHistoryPanelState, StageEntryFile> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        component: <StageEntryHistoryPanel id={this.model.id} permissions={this.model.permissions()} />,
      },
    ];
  }
}

export default StageEntryHistoryPanelView;
